"use strict";

exports.__esModule = true;
exports.default = void 0;
var _index = require("../../../swcp-base/js/index");
var _index2 = require("../../../swcp-base/js/helpers/index");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const invitationRoleActions = new _index.JoinActionHelper("invitation", "role");
const invitationActions = new _index.ActionHelper({
  singular: "invitation"
});
class Actions extends _index.ActionHelper {
  constructor() {
    super({
      singular: "invitation"
    });
    _defineProperty(this, "addRole", body => invitationRoleActions.create(body, this));
    _defineProperty(this, "dropRole", id => invitationRoleActions.destroy(id, this));
    _defineProperty(this, "getMyInvitation", (id, params) => invitationActions.get(id, params, this, false));
    _defineProperty(this, "get", (id, params, module) => invitationActions.get(id, params, this));
    _defineProperty(this, "getAll", (params, module) => invitationActions.getAll(params, this));
    _defineProperty(this, "isAdminUser", () => {
      let adminLicenseId = "039d6fdd-53c2-408a-b924-f07505d15a34";
      return (0, _index2.createRequest)(true).then(request => {
        request.method = "get";
        request.url = "/users/me?expand=UserLicenses";
        return (0, _index2.sendRequest)(request).then(response => {
          for (let license of response.data.UserLicenses) {
            if (license.LicenseId === adminLicenseId) return true;else return false;
          }
        }).catch(error => {
          console.dir(error);
        });
      }).catch(error => {
        console.dir(error);
      });
    });
    _defineProperty(this, "preCreate", (request, params) => {
      request.data.UserLicense = {
        LicenseId: request.data["UserLicense"]
      };
      return request;
    });
    _defineProperty(this, "create", (body, params) => invitationActions.create(body, params, this, true));
  }
  /*
  We don't show invitations to "Developer" users if the user has an Admin license.
  */

  async preGetAll(getAllRequest, params) {
    if (params.filter) params.filter += " and ";
    let developerLicenseId = "91f2e5b9-5149-455d-b5d3-339f6de344db";
    let adminUser = await this.isAdminUser();
    if (adminUser === true) {
      params.filter += `UserLicense.LicenseId <> "${developerLicenseId}"`;
      getAllRequest.url = `${this._uri}${(0, _index2.paramsToString)(params)}`;
      return getAllRequest;
    } else {
      return getAllRequest;
    }
  }
}
const actions = new Actions();
var _default = exports.default = actions;
module.exports = exports.default;